<template>
  <div class="tag-wrapper">
    <span
      class="label tag-communications table-tag-content"
      v-if="list.length > 0"
      @mouseenter="showTable = true"
      @mouseleave="showTable = false"
      >#{{ list.length }} <i class="fas fa-satellite comm-icon-main "></i>
    </span>

    <div v-if="showTable" class="tag-table pop-up-for-tags ">
      <div class="table-responsive ">
        <table class="table table-condensed">
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>{{ item.created_at | shortTime }}</td>
              <td>{{ formatDateTable(item.created_at) }}</td>
              <td>{{ item.type.name }}</td>
              <td>
                <strong>{{ item.contacted_in }}</strong>
              </td>
              <td>{{ item.user.full_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "communications",

  props: {
    list: {
      type: Array,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      showTable: false,
      filteredList: [],
      showPanel: false
    };
  },
  methods: {
    findUser(id) {
      return this.salesPersonList.find(function(element) {
        return element.id === id;
      });
    },

    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  },

  computed: {
    ...mapState("clients", ["salesPersonList"]),
    phoneCalls() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "phone") {
          items.push(c);
        }
      });

      return items;
    },

    sentEmails() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "email_sent") {
          items.push(c);
        }
      });

      return items;
    },

    receivedEmails() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "email_received") {
          items.push(c);
        }
      });

      return items;
    },

    skypeCalls() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "skype") {
          items.push(c);
        }
      });

      return items;
    },

    chats() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "chat") {
          items.push(c);
        }
      });

      return items;
    },

    sms() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "sms") {
          items.push(c);
        }
      });

      return items;
    },
    whatsapp() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "whatsapp") {
          items.push(c);
        }
      });

      return items;
    },
    viber() {
      let items = [];

      this.list.forEach(c => {
        if (c.type.name === "viber") {
          items.push(c);
        }
      });

      return items;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-table {
  bottom: 40px;

  border: solid 1px #ffed16;
}

/*.tag-communications {
      background-color: #fdd835;
      color: #212121;
      font-size: 10px;
      border-radius: 3px;
      margin: 2px;
      padding: 4px;
      font-weight: 900;
      line-height: 2;
      text-align: center;
      white-space: nowrap;
      vertical-align: baseline;
      font-family: "Montserrat" !important;
    }*/

.tag-communications {
  background-color: #ffed16;
  /*font-size: 11px !important;*/
  /*font-size: 12px;*/
  /*color: black;*/
  /*margin: 1px;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*animation: flash linear 1s;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

/*
    .tag-communications span {
      margin: 3px;
    }
    */

.tag-communications-part {
  padding-right: 2px;
}

.skype {
  color: #212121;
  cursor: pointer;
}

.table-responsive {
  //  margin-bottom: -20px;
}

.table {
  margin-bottom: 0px !important;
}

.comm-icon {
  font-size: 10pt;
}

.comm-icon-main {
  font-size: 14px;
}

.viber-icon {
  width: 13px;
  margin-top: -2px;
}

.remove-tag-icon {
  color: #212121;
  cursor: pointer;
  margin-left: 5px;
}

.remove-tag-icon:hover {
  color: #f44336;
}

/* .comm-menu{
      width: 20px;
      height: 40px;
      background-color: black;
      transition: width 2s, height 4s;
      position: absolute;
    }
     .comm-menu-big{
        height: 140px;
        position: absolute;
        left: 0;
      }*/
.label {
  font-weight: 500;
  /*font-size: 14px !important;*/
}
.table-tag-content {
  line-height: 2.3;
  min-width: 43px !important;
}

.table-tag-content {
  min-width: 38px !important;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
</style>
